import { render, staticRenderFns } from "./RC_resource.vue?vue&type=template&id=ed1609ea&scoped=true"
import script from "./RC_resource.vue?vue&type=script&lang=js"
export * from "./RC_resource.vue?vue&type=script&lang=js"
import style0 from "./RC_resource.vue?vue&type=style&index=0&id=ed1609ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1609ea",
  null
  
)

export default component.exports